import React, { ChangeEvent, FC, useState } from 'react';
import TextField from '@mui/material/TextField';
import isEmpty from 'lodash/isEmpty';
import Modal from 'components/common/Modal';
import { Button, ButtonVariant } from 'components/common/buttons/Button';
import { IndividualWebhookEndpoint } from 'api/admin/businesses/getWebhookEndpoints';
import styles from './EditWebhookEndpointsModal.module.scss';
import { useAddWebhookEndpoint } from './mutations/useAddWebhookEndpoint';
import { useDeleteWebhookEndpoint } from './mutations/useDeleteWebhookEndpoint';
import { useEditWebhookEndpoint } from './mutations/useEditWebhookEndpoint';

export const EditWebhookEndpointsModal: FC<{
  isNew: boolean;
  businessId: number;
  endpoint: IndividualWebhookEndpoint | null;
  onClose: (shouldReload: boolean) => void;
}> = ({ isNew, businessId, endpoint, onClose }) => {
  const [webhookEndpoint, setWebhookEndpoint] = useState<string | null>(
    endpoint?.webhookEndpoint ?? null,
  );

  const { mutateAsync: onAddWebhookEndpoint } = useAddWebhookEndpoint();
  const { mutateAsync: onEditWebhookEndpoint } = useEditWebhookEndpoint();
  const { mutateAsync: onDeleteWebhookEndpoint } = useDeleteWebhookEndpoint();

  const handleWebhookEndpointChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setWebhookEndpoint(value.trim());
  };

  const handleSave = async () => {
    if (isNew) {
      await onAddWebhookEndpoint({ businessId, webhookEndpoint });
    } else {
      await onEditWebhookEndpoint({ businessId, webhookEndpoint, configId: endpoint.id });
    }

    onClose(true);
  };

  const handleDelete = async () => {
    await onDeleteWebhookEndpoint({ businessId, configId: endpoint.id });

    onClose(true);
  };

  return (
    <Modal modalHeight="300px" onClose={() => onClose(false)}>
      <div className={styles.editEndpointFormContainer}>
        <h1 className={styles.editEndpointFormContainerHeader}>
          {`${isNew ? 'Add' : 'Edit'} Webhook Endpoint`}
        </h1>
        <div className={styles.editEndpointFormContainerRow}>
          <p>Endpoint</p>
          <TextField
            variant="outlined"
            value={webhookEndpoint}
            onChange={handleWebhookEndpointChange}
          />
        </div>
        <div>
          {!isNew && (
            <Button
              isDisabled={isNew}
              type={ButtonVariant.CONTAINED}
              onClick={handleDelete}
              style={{ width: '150px', backgroundColor: '#ff0000', marginRight: '15px' }}
            >
              Delete
            </Button>
          )}
          <Button
            isDisabled={isEmpty(webhookEndpoint)}
            type={ButtonVariant.CONTAINED}
            onClick={handleSave}
            style={{ width: '150px' }}
          >
            {`${isNew ? 'Add' : 'Save'}`}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
